const homeStoriesSec = document.querySelector('.home-stories-sec');
if (homeStoriesSec) {
  const gridCardsEl = homeStoriesSec.querySelector('.home-stories-sec__grid');

  if (gridCardsEl) {
    const cardTitlesArr = gridCardsEl.querySelectorAll('.home-story-card__title');
    const cardTextsArr = gridCardsEl.querySelectorAll('.home-story-card__text');

    if(cardTextsArr.length && window.innerWidth >= 768) {
      lineTitlesFunc(cardTextsArr);
    }

    if(cardTitlesArr.length && window.innerWidth >= 768) {
      lineTitlesFunc(cardTitlesArr);
    }
  }
}